import React, { ReactNode } from "react";

export interface IArea {
  register(params?: any): void;
}

export default class Area {
  protected createPage({ action, Page, ...params }) {
    return (props) => {
      const args = props.params;
      const output = action(args);
      return React.createElement(
        Page,
        Object.assign({}, output, props),
        {} as ReactNode
      );
    };
  }
}
